import Button from 'antd/lib/button';
import Popconfirm from 'antd/lib/popconfirm';
import Space from 'antd/lib/space';
import * as React from 'react';
import { runwayColors, antGrey } from '../styles/globalStyles';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import Tooltip from 'antd/lib/tooltip';
import { Link } from 'react-router-dom';
import { createOrgSettingsRoute } from '../../helpers/routeHelpers';
import { OrgSettingsTabType } from '@/typescriptHelpers';

interface CLIEditActionsProps {
    orgId: string;
    itemId: string;
    deleteIsLoading: boolean;
    onConfirmDelete: (id: string) => void;
    onEditChecklistItem: (id: string) => void;
    disableEditButton: boolean;
    disableDeleteButton?: boolean;
    shouldDisableOrgLevelCliActions: boolean;
}

const CLIEditActions: React.FC<CLIEditActionsProps> = (props: CLIEditActionsProps) => {
    const [deletePopoverVisible, setDeletePopoverVisible] = React.useState(false);

    const disableOrgLevelActionsTooltipContent = () => {
        return (
            <>
                {' '}
                This checklist item affects multiple workflows. Visit{' '}
                <Link
                    to={createOrgSettingsRoute(props.orgId, OrgSettingsTabType.Checklists)}
                    style={{ color: runwayColors.white, textDecoration: 'underline' }}
                >
                    Organization settings
                </Link>{' '}
                to make changes.
            </>
        );
    };

    const deleteCLIButton = () => {
        return (
            <span>
                <Popconfirm
                    open={deletePopoverVisible}
                    title="Are you sure you want to delete this item? It will be deleted from all active and future releases."
                    okText="Yes, delete."
                    okButtonProps={{ loading: props.deleteIsLoading }}
                    onConfirm={() => props.onConfirmDelete(props.itemId)}
                    onCancel={() => setDeletePopoverVisible(false)}
                    overlayStyle={{ maxWidth: 400 }}
                    placement="topRight"
                >
                    <Button
                        disabled={props.disableDeleteButton || props.shouldDisableOrgLevelCliActions}
                        loading={props.deleteIsLoading}
                        icon={
                            <DeleteOutlined
                                style={{
                                    color:
                                        props.shouldDisableOrgLevelCliActions ? antGrey.grey6 : runwayColors.statusRed,
                                }}
                            />
                        }
                        type="link"
                        onClick={() => {
                            setDeletePopoverVisible(true);
                        }}
                        style={{ width: 24, height: 24 }}
                    />
                </Popconfirm>
            </span>
        );
    };

    const editCLIButton = () => {
        return (
            <span>
                <Button
                    disabled={props.disableEditButton || props.shouldDisableOrgLevelCliActions}
                    icon={<EditOutlined />}
                    type="link"
                    onClick={() => props.onEditChecklistItem(props.itemId)}
                    style={{ width: 24, height: 24 }}
                />
            </span>
        );
    };

    return (
        <Space align="center">
            {props.shouldDisableOrgLevelCliActions ?
                <Tooltip title={disableOrgLevelActionsTooltipContent()}>{deleteCLIButton()}</Tooltip>
            :   deleteCLIButton()}
            {props.shouldDisableOrgLevelCliActions ?
                <Tooltip title={disableOrgLevelActionsTooltipContent()}>{editCLIButton()}</Tooltip>
            :   editCLIButton()}
        </Space>
    );
};

export default CLIEditActions;
